<div class="app-shell" *ngIf="!isLoggedIn">
  <div class="app-shell__content">
    <router-outlet />
  </div>
  <app-footer />
</div>

<app-dashboard-layout *ngIf="isLoggedIn"></app-dashboard-layout>

<p-toast />
